<template>
  <img :src="avatarImage" id="movingHead" class="avatar round" alt="Tumi avatar" width="130">
</template>

<script>
  export default {
    name: 'TumiAvatar',
    data: () => ({
      avatarImage: '/img/tumi/tumi.jpg'
    }),
    methods: {
      mouseIsMoving(event) {
        // console.log(event);
        const headPosition = document.querySelector('#movingHead')
          .getBoundingClientRect()
        const aboveHead = event.clientY < headPosition.top
        const belowHead = event.clientY > headPosition.bottom
        const leftOfHead = event.clientX < headPosition.left
        const rightOfHead = event.clientX > headPosition.right
        if (aboveHead && leftOfHead) {
          this.avatarImage = '/img/tumi/looking-top-left.jpg'
        } else if (aboveHead && rightOfHead) {
          this.avatarImage = '/img/tumi/looking-top-right.jpg'
        } else if (aboveHead) {
          this.avatarImage = '/img/tumi/looking-up.jpg'
        } else if (belowHead && leftOfHead) {
          this.avatarImage = '/img/tumi/looking-bottom-left.jpg'
        } else if (belowHead && rightOfHead) {
          this.avatarImage = '/img/tumi/looking-bottom-right.jpg'
        } else if (belowHead) {
          this.avatarImage = '/img/tumi/looking-down.jpg'
        } else if (leftOfHead) {
          this.avatarImage = '/img/tumi/looking-left.jpg'
        } else if (rightOfHead) {
          this.avatarImage = '/img/tumi/looking-right.jpg'
        } else {
          this.avatarImage = '/img/tumi/tumi.jpg'
        }
      }
    },
    mounted() {
      window.addEventListener('mousemove', this.mouseIsMoving)
    }
  }
</script>
